import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { GuideValues, StudioViewPositions, StudioMode } from '../../../configs/studio';

export const setOpenStudio = action(
  'SET_OPEN_STUDIO',
  withPayload<boolean>(),
);

export const setupStudio = action(
  'SET_SETUP_STUDIO',
  withoutPayload,
);

export const setOpenSettingsPanel = action(
  'SET_OPEN_SETTINGS_PANEL',
  withPayload<boolean>(),
);

export const setRecordingAfterDelay = action(
  'SET_RECORDING_AFTER_DELAY',
  withPayload<boolean>(),
);

export const setGuideStudio = action(
  'SET_GUIDE_STUDIO',
  withPayload<GuideValues>(),
);

export const setTextStudio = action(
  'SET_TEXT_STUDIO',
  withPayload<string>(),
);

export const setAutoScrolling = action(
  'SET_AUTO_SCROLLING_STUDIO',
  withPayload<boolean>(),
);

export const setRunningAudioService = action(
  'SET_RUNNING_AUDIO_SERVICE_STUDIO',
  withPayload<boolean>(),
);

export const setConnectingAudioService = action(
  'SET_CONNECTING_AUDIO_SERVICE_STUDIO',
  withPayload<boolean>(),
);

export const setCalibratingAudioService = action(
  'SET_CALIBRATING_AUDIO_SERVICE_STUDIO',
  withPayload<boolean>(),
);

export const setScrollSpeed = action(
  'SET_SCROLL_SPEED_STUDIO',
  withPayload<number>(),
);

export const setFontSize = action(
  'SET_FONT_SIZE_STUDIO',
  withPayload<number>(),
);

export const setMediaNotAvailable = action(
  'SET_MEDIA_NOT_AVAILABLE_STUDIO',
  withPayload<boolean>(),
);
export const setStartDelayTime = action(
  'SET_START_DELAY_TIME_STUDIO',
  withPayload<number>(),
);

export const setScrollIntervalId = action(
  'SET_SCROLL_INTERVAL_ID_STUDIO',
  withPayload<number | null>(),
);

export const setAudioServiceTimeoutId = action(
  'SET_AUDIO_SERVICE_TIMEOUT_ID_STUDIO',
  withPayload<number | null>(),
);

export const setBookmarkPosition = action(
  'SET_BOOKMARK_POSITION_STUDIO',
  withPayload<number | null>(),
);

export const setAverageCalibrateVolume = action(
  'SET_AVERAGE_CALIBRATE_VOLUME_STUDIO',
  withPayload<number>(),
);

export const setScrollPosition = action(
  'SET_SCROLL_POSITION',
  withPayload<() => void>(),
);

export const setAutoScrollAudioService = action(
  'SET_AUTO_SCROLL_AUDIO_SERVICE_STUDIO',
  withPayload<boolean>(),
);

export const setHomeAction = action(
  'SET_HOME_ACTION_STUDIO',
  withPayload<boolean>(),
);
export const setBookmarkAction = action(
  'SET_BOOKMARK_ACTION_STUDIO',
  withPayload<boolean>(),
);

export const setPlayPrompter = action(
  'SET_PLAY_PROMPTER_STUDIO',
  withPayload<boolean>(),
);

export const setSetupAndTogglePrompter = action(
  'SET_SETUP_AND_TOGGLE_PROMPTER_STUDIO',
  withoutPayload,
);

export const setRestartPrompter = action(
  'SET_RESTART_PROMPTER_STUDIO',
  withoutPayload,
);

export const setCountdown = action(
  'SET_COUNTDOWN_STUDIO',
  withPayload<boolean>(),
);

export const setRunCountdown = action(
  'SET_RUN_COUNTDOWN',
  withoutPayload,
);

export const setStopCountdown = action(
  'SET_STOP_COUNTDOWN',
  withoutPayload,
);

export const setPlayPrompterWithAudioCountdown = action(
  'SET_PLAY_PROMPTER_WITH_AUDIO_COUNTDOWN',
  withoutPayload,
);

export const setCurrentCountdown = action(
  'SET_CURRENT_COUNTDOWN',
  withPayload<number>(),
);
export const setSupportUserMedia = action(
  'SET_SUPPORT_USER_MEDIA',
  withPayload<boolean>(),
);

export const setSupportUserAudio = action(
  'SET_SUPPORT_USER_AUDIO',
  withPayload<boolean>(),
);

export const setDropdownSelectMode = action(
  'SET_DROPDOWN_SELECT_MODE_STUDIO',
  withPayload<boolean>(),
);

export const setStudioMode = action(
  'SET_STUDIO_MODE',
  withPayload<StudioMode>(),
);

export const setCameraRecording = action(
  'SET_CAMERA_RECORDING',
  withPayload<boolean>(),
);

export const setStudioMainContainerHeight = action(
  'SET_STUDIO_MAIN_CONTAINER_HEIGHT',
  withPayload<number>(),
);

export const setStudioTopView = action(
  'SET_STUDIO_TOP_VIEW',
  withPayload<StudioViewPositions>(),
);

export const setStudioBottomView = action(
  'SET_STUDIO_BOTTOM_VIEW',
  withPayload<StudioViewPositions>(),
);

export const setRecordCount = action(
  'SET_RECORD_COUNT_STUDIO',
  withPayload<number>(),
);

export const setCameraReady = action(
  'SET_CAMERA_READY',
  withPayload<boolean>(),
);

export const setCameraError = action(
  'SET_CAMERA_ERROR',
  withPayload<boolean>(),
);

export const setCountdownCamera = action(
  'SET_COUNTDOWN_CAMERA',
  withPayload<boolean>(),
);

export const toggleCameraRecording = action(
  'TOGGLE_CAMERA_RECORDING',
  withoutPayload,
);

export const restartRecordingCamera = action(
  'RESTART_RECORDING',
    withoutPayload,
)

export const setCameraId = action(
  'SET_CAMERA_ID',
  withPayload<string>(),
);

export const setAudioId = action(
  'SET_AUDIO_ID',
  withPayload<string>(),
);

export const setTeleprompterSync = action(
  'SET_TELEPROMTER_SYNC',
  withPayload<boolean>(),
);
